import React from 'react'
import categoryimg from '../../images/banner-games-01.webp'

export default function category() {
  return (
    <div className="bnr custom-caption image-hover-scale image-hover-scale--slow bnr--middle bnr--center fontratio-calc">
    <div className="bnr-img  image-container">
        <img src={categoryimg} className="fade-up lazyloaded img-fluid" alt="" />


        </div>

        <div className="bnr-caption">
                    <div className="bnr-text1 mt-0 order-1" >2 0 2 0</div>
                    <div className="bnr-text2 mt-xs order-2 " >CALL OF LIFE</div>
                    <div className="bnr-text3 mt-xs order-2 " >Last day, last hope</div>
                </div>



</div>
  )
}
